module.exports = __webpack_public_path__ + "static/media/vguard.2019f8d3.png";